/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintain_Clock_Times_HelpInputs */

const en_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The timing will remain the same, but will be represented by different SMPTE timecode values`)
};

const fr_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le minutage restera identique, mais sera représenté par des valeurs de timecode SMPTE différentes`)
};

const de_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeitmessung bleibt gleich, wird aber durch unterschiedliche SMPTE-Timecode-Werte dargestellt.`)
};

const it_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La temporizzazione rimarrà la stessa, ma sarà rappresentata da diversi valori di timecode SMPTE`)
};

const ru_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время останется прежним, но будет отображаться другими значениями временного кода SMPTE.`)
};

const es_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tiempo seguirá siendo el mismo, pero estará representado por diferentes valores de código de tiempo SMPTE.`)
};

const zh_cn2_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间轴保持不变，但会用不同的 SMPTE 时间码值表示。`)
};

const ja_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングは同じままですが、異なるSMPTEタイムコード値で表されます。`)
};

const hi_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय वही रहेगा, लेकिन इसे अलग-अलग SMPTE टाइमकोड मानों द्वारा दर्शाया जाएगा।`)
};

const pt_pt2_maintain_clock_times_help = /** @type {(inputs: Maintain_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sincronização permanecerá a mesma, mas será representada por diferentes valores de código de tempo SMPTE.`)
};

/**
* | output |
* | --- |
* | "The timing will remain the same, but will be represented by different SMPTE timecode values" |
*
* @param {Maintain_Clock_Times_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maintain_clock_times_help = /** @type {((inputs?: Maintain_Clock_Times_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintain_Clock_Times_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_maintain_clock_times_help(inputs)
	if (locale === "de") return de_maintain_clock_times_help(inputs)
	if (locale === "it") return it_maintain_clock_times_help(inputs)
	if (locale === "ru") return ru_maintain_clock_times_help(inputs)
	if (locale === "es") return es_maintain_clock_times_help(inputs)
	if (locale === "zh-CN") return zh_cn2_maintain_clock_times_help(inputs)
	if (locale === "ja") return ja_maintain_clock_times_help(inputs)
	if (locale === "hi") return hi_maintain_clock_times_help(inputs)
	if (locale === "pt-PT") return pt_pt2_maintain_clock_times_help(inputs)
	return en_maintain_clock_times_help(inputs)
});